import React from 'react';
import { animated } from 'react-spring';

import styles from './style.css';

const Blog = ({ image, style, name, description, link }) => (
  <animated.article style={style} className={styles.blog}>
    <div className={styles.blog__inner}>
      <a target="_blank" rel="noopener noreferrer" href={link}>
        <div className={styles.blog__container}>
          <picture className={styles.blog__logo}>
            <source type="image/webp" srcSet={image} />
            <source srcSet={image} />
            <img alt={name} />
          </picture>
          <div className={styles.blog__header}>
            <h1 className={styles.blog__name}>{name}</h1>
          </div>
          <p className={styles.blog__description}>{description}</p>
        </div>
      </a>
    </div>
  </animated.article>
);

export default Blog;
